const setPassword = {
  confirmationError: 'Your account could not be verified.',
  confirmationSuccessful: 'Your account has been verified!',
  title: 'Set Password',
  description: 'Enter your new password here. We will ask for this password when you log in again.',
  repeatPassword: 'Confirm new password',
  changePasswordAction: 'Change password',
}

export default setPassword
